import React from 'react'
import classNames from 'classnames/bind'

import styles from './blog-skeleton-page.module.scss'
import { FluidImage } from 'components/shared/fluid-image/FluidImage'

const cx = classNames.bind(styles)

export const BlogSkeletonPage = ({blogData}) => {
    const {
        blogHeading,
        blogDate,
        mainImage,
        description,
    } = blogData

    return (
        <div className={cx("blog-page")}>
            <div className={cx("container")}>
                <h1>{blogHeading}</h1>
                <p className={cx('blog-date')}>{blogDate}</p>

                <div className={cx(['row'])}>
                    {mainImage && (
                        <span className={cx('col-12')}>
                            <FluidImage altText={mainImage.alt} image={mainImage.image} />
                        </span>
                    )}

                    {description.map( (text, index) => {
                        return (
                            <p className={cx("col-12")} key={index} dangerouslySetInnerHTML={{__html: text}}></p>
                        )})
                    }
                </div>
            </div>
        </div>
    )
}